import { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import QuizPage from './pages/QuizPage';
import LoadingPage from './pages/LoadingPage';
import PlanPage from './pages/PlanPage';
import AuthPage from './pages/AuthPage';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ShippingReturn from './pages/ShippingReturn';
import AboutUs from './pages/AboutUs';
import RefundPolicy from './pages/RefundPolicy';
import TermsConditions from './pages/TermsConditions';
import ContactUs from './pages/ContactUs';
import AdminPanel from './pages/AdminPanel';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';

function AppRouter() {
  const location = useLocation();
  const [quizAnswers, setQuizAnswers] = useState({});

  const updateAnswer = (key, value) => {
    setQuizAnswers((prev) => ({ ...prev, [key]: value }));
  };

  // Check URL fragment (not query params) for session_id (Emergent Google OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage answers={quizAnswers} updateAnswer={updateAnswer} />} />
      <Route path="/quiz" element={<QuizPage answers={quizAnswers} updateAnswer={updateAnswer} />} />
      <Route path="/loading" element={<LoadingPage answers={quizAnswers} />} />
      <Route path="/plan" element={<PlanPage answers={quizAnswers} />} />
      <Route path="/login" element={<AuthPage mode="login" />} />
      <Route path="/register" element={<AuthPage mode="register" />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/refund-policy" element={<RefundPolicy />} />
      <Route path="/shipping-return" element={<ShippingReturn />} />
      <Route path="/terms" element={<TermsConditions />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/admin" element={<AdminPanel />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#0d0e10] text-white">
      <BrowserRouter>
        <LanguageProvider>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
